import { pluralize } from "web/services/inflector"

export const paramsToQueryString = (paramsObj = {}) => {
  const params = new URLSearchParams("")
  Object.entries(paramsObj).forEach(([k, v]) => {
    if (!v) {
      return
    }

    if (Array.isArray(v)) {
      v.forEach((av) => {
        params.append(k, av)
      })
    } else {
      params.append(k, v)
    }
  })

  return params.toString()
}

const viewSubject = (section) => (viewGroupSlug, viewId, id) =>
  viewId
    ? `/${section}/${viewGroupSlug}/${viewId}/view/${id}`
    : `/${section}/${viewGroupSlug}/view/${id}`

const listSubjects = (section) => (viewGroupSlug, viewId) =>
  viewId
    ? `/${section}/${viewGroupSlug}/${viewId}`
    : `/${section}/${viewGroupSlug}`

const routes = {
  // helpers
  root: (page) => (page ? `/${page}` : "/"),

  tlo: (section, viewGroupSlug, viewId, id) =>
    viewSubject(section)(viewGroupSlug, viewId, id),

  tloList: (section) => `/${section}`,

  tloTopic: (section, viewGroupSlug, viewId, id, topicName) =>
    `${viewSubject(section)(viewGroupSlug, viewId, id)}/details/${topicName}`,

  view: (section, viewGroupSlug, viewId, topicName) =>
    `/${section}/${!!topicName ? `topic/${topicName}/` : ""}${viewGroupSlug}${
      !!viewId ? `/${viewId}` : ""
    }`,

  market_view: (parent_subject_slug, subjectType, viewId, topicName) =>
    `/markets/${parent_subject_slug}/${pluralize(subjectType)}${
      !!topicName ? `/topics/${topicName}` : ""
    }${!!viewId ? `/${viewId}` : ""}`,

  // paths throughout the app
  asset: viewSubject("assets"),
  assetsMap: (viewGroupSlug, viewId, params) =>
    `${listSubjects("assets")(viewGroupSlug, viewId)}/map?${paramsToQueryString(
      params
    )}`,

  deals: () => "/deals",
  deal: viewSubject("deals"),
  bulkEditDealOutcome: (outcome, ids) =>
    `/deals/bulk_actions/${outcome}/edit?${paramsToQueryString(ids)}`,

  deal_asset: (viewGroupSlug, viewId, dealId, dealAssetId) =>
    `${viewSubject("deals")(
      viewGroupSlug,
      viewId,
      dealId
    )}/deal_assets/${dealAssetId}`,

  dealsTasks: () => "/tasks",

  company: viewSubject("companies"),
  portfolio: viewSubject("portfolios"),

  file: (id) => `/files/view/${id}`,
  settings: () => "/settings",
  settingsFields: (subjectType, topicId) => {
    if (topicId) {
      return `/settings/configuration/topics/${topicId}/fields/`
    } else {
      if (subjectType === "sale") {
        return "/settings/configuration/deals/fields/"
      } else if (subjectType === "sale_asset") {
        return "/settings/configuration/deal_assets/fields/"
      } else {
        return `/settings/configuration/${pluralize(subjectType)}/fields/`
      }
    }
  },
  workflowTemplate: (workflow_template) =>
    `/settings/workflow_templates/${pluralize(
      workflow_template.kind.toLowerCase()
    )}/${workflow_template.id}`,
  workflowTemplateStage: (workflow_template, stage) =>
    `/settings/workflow_templates/${pluralize(
      workflow_template.kind.toLowerCase()
    )}/${workflow_template.id}/stages/${stage.id}`,
  signOut: () => "/sign_out",
  notFound: () => "/404",
  profileEdit: () => "/profile/edit",
  ssrNewTopicRecord: (subjectType, subjectId, topicName) =>
    `/${pluralize(subjectType)}/${subjectId}/topics/${topicName}/records/new`,
  ssrEditTopicRecord: ({
    subjectType,
    subjectId,
    topicName,
    id,
    isCrossSubject = false,
  }) =>
    `/${pluralize(
      subjectType
    )}/${subjectId}/topics/${topicName}/records/${id}/edit?is_cross_subject=${isCrossSubject}`,
  editTopicIdentity: (topicId) => `/settings/topics/${topicId}/edit`,
}

const SECTION_LOOKUP = {
  Asset: "assets",
  Deal: "deals",
  Company: "companies",
  Portfolio: "portfolios",
  Task: "tasks",
  Contact: "contacts",
}

export const subjectTypeToSection = (subectType) => SECTION_LOOKUP[subectType]

export default routes
